import router from '@/router';
import store from '@/store';

import { isEmpty } from 'lodash';
import fillParams from '@/utils/params';
// function isTabs(to) {
//   return to.matched.some(r => r.meta.tabs === true) &&
//     to.matched.every(r => r.meta.tabs !== false);
// }

function tabKey(route) {
  const { matched } = route;
  const { path } = matched[matched.length - 1];
  return fillParams(path, route.params);
}

router.beforeEach((to, from, next) => {
  // if (!to.name || !isTabs(to)) { next(); return; }
  if (!to.meta.tab) { next(); return; }
  const { tabs } = store.state.App.TabsBar;
  const key = tabKey(to);
  const tab = tabs.find(t => t.key === key);
  if (tab && !isEmpty(tab.query) && isEmpty(to.query)) next({ ...tab, replace: true });
  else next();
});

router.beforeResolve((to, from, next) => {
  // if (!to.name || !isTabs(to)) return;
  if (!to.meta.tab) { next(); return; }
  const { matched, ...route } = to; // avoid infinite loop obseving matched
  // const titles = [];
  // matched
  //   .slice()
  //   .reverse()
  //   .some((route) => {
  //     if (route.meta.title) titles.push(route.meta.title);
  //     return !!route.meta.rootTab;
  //   });
  let { tab } = to.meta;
  if (typeof tab === 'string') tab = { i18n: tab };
  const key = tabKey(to);
  store.dispatch('App/TabsBar/addOrUpdateTab', { ...route, ...tab, key });
  next();
});
